import { propertyListActionTypes as actions } from '~constants/actionTypes';
import { fetch } from '~actions/pms-actions/shared';
import { sortDirectionMapping, sortByMapping } from '~constants';
import { pmsEndpoints } from '~settings/endpoints';
import { formatSimpleParams } from '~helpers/params';
import * as queries from '~settings/pms-queries';
// import { isLandlordRole } from '~helpers/auth';
export const initialize = () => ({
  type: actions.INITIALIZE,
});

export const setPropertyList = payload => ({
  type: actions.SET_LIST,
  payload: payload.properties,
});

export const getPropertyList =
  (params, successCallback = () => {}) =>
  dispatch => {
    const propertyParams = params;
    // if (isLandlordRole()) {
    //   if (!params.statuses) {
    //     propertyParams.statuses = ['EDITING', 'PUBLISHED', 'UNPUBLISHED', 'NEW'];
    //   }
    // }
    if (propertyParams?.sort) {
      propertyParams.sortBy = propertyParams.sort?.toUpperCase();
    }
    fetch({
      dispatch,
      endpoint: pmsEndpoints.getPropertyList.url(),
      params: queries.properties(
        formatSimpleParams(
          {
            pageNumber: 1,
            pageSize: 10,
            sortBy: sortByMapping.updatedAt,
            sortDirection: sortDirectionMapping.descend,
            countrySlug: null,
            citySlug: null,
            landlordSlug: null,
            statuses: null,
            fullName: null,
            propertyType: null,
            isCheckAuth: propertyParams?.hasHerculesProperties ? false : undefined,
            bookingJourneys: null,
          },
          propertyParams,
        ),
      ),
      communicationType: actions.LIST_CS,
      successAction: setPropertyList,
      onSuccess: successCallback,
    });
  };

export const setProperty = (index, property) => ({
  type: actions.SET_PROPERTY_IN_LIST,
  index,
  property,
});

export const createProperty =
  (params, successCallback = () => {}, failedCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.createProperty.url(),
      params: queries.createProperty(
        formatSimpleParams(
          {
            name: null,
            latitude: 0,
            longitude: 0,
            address: null,
            country: null,
            cityId: null,
            currency: null,
            postalCode: null,
            landlordId: null,
            propertyType: null,
            shippingCity: null,
            bookingJourney: 'SEMI_AUTOMATIC',
          },
          params,
        ),
      ),
      communicationType: actions.CREATE_PROPERTY_CS,
      onSuccess: successCallback,
      onError: failedCallback,
    });
  };

export const updatePropertyNote =
  (params, successCallback = () => {}, failedCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.updateProperty.url(),
      params: queries.updateProperty(params),
      communicationType: actions.UPDATE_PROPERTY_RECORD_NOTE_CS,
      onSuccess: successCallback,
      onError: failedCallback,
    });
  };

export const editPropertyNote =
  (params, successCallback = () => {}, failedCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.recordModal.url(),
      params: queries.updatePropertyContractNote(params),
      communicationType: actions.EDIT_PROPERTY_RECORD_NOTE_CS,
      onSuccess: successCallback,
      onError: failedCallback,
    });
  };

export const deletePropertyNote =
  (params, successCallback = () => {}, failedCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.recordModal.url(),
      params: queries.deletePropertyContractNote(params),
      communicationType: actions.DELETE_PROPERTY_RECORD_NOTE_CS,
      onSuccess: successCallback,
      onError: failedCallback,
    });
  };
